/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerAssignmentCreateBodyTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerAssignmentCreateBodyExpectedCustomerVersionExclusiveMin = 0;
export const customerAssignmentCreateBodyExpectedCustomerVersionMax = 9007199254740991;

export const CustomerAssignmentCreateBody = zod.object({
  teamId: zod.uuid().regex(customerAssignmentCreateBodyTeamIdRegExp),
  expectedCustomerVersion: zod
    .int()
    .gt(customerAssignmentCreateBodyExpectedCustomerVersionExclusiveMin)
    .max(customerAssignmentCreateBodyExpectedCustomerVersionMax),
});

export type CustomerAssignmentCreateBody = zod.input<typeof CustomerAssignmentCreateBody>;
export type CustomerAssignmentCreateBodyOutput = zod.output<typeof CustomerAssignmentCreateBody>;
